import { forwardRef, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMatModule } from '../../app-mat.module';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DatetimePickerComponent } from './datetime-picker.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

@NgModule({
  imports: [
    CommonModule,
    AppMatModule,
    NgxMaterialTimepickerModule
  ],
  declarations: [DatetimePickerComponent],
  exports: [
    DatetimePickerComponent,
  ],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DatetimePickerComponent),
    multi: true
  }]
})
export class DatetimePickerModule { }